new Vue({
  el: '#app',
  data() {
    return {
      // ascription 1 集团 2 分期 3 未来营 4 圈招
      // type 1 文档 2 ppt 3 视频 4 图片
      ascription: 0,
      type: 0,
      files: [
        {
          ascription: 1,
          type: 1,
          title: '集团文档',
          link: '/'
        },
        {
          ascription: 2,
          type: 2,
          title: '分期PPT',
          link: '/'
        }
      ]
    }
  },
  computed: {
    list () {
      return this.files.filter(e => {
        if (this.ascription) {
          if (this.type) {
            return e.ascription === this.ascription && e.type === this.type
          } else {
            return e.ascription === this.ascription
          }
        } else {
          if (this.type) {
            return e.type === this.type
          } else {
            return true
          }
        }
      })
    }
  }
})